import { render, staticRenderFns } from "./vietnamErr.vue?vue&type=template&id=1eafbffe&scoped=true&"
import script from "./vietnamErr.vue?vue&type=script&lang=ts&"
export * from "./vietnamErr.vue?vue&type=script&lang=ts&"
import style0 from "./vietnamErr.vue?vue&type=style&index=0&id=1eafbffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eafbffe",
  null
  
)

export default component.exports